(function () {
  'use strict';

  angular.module('app').component('clientList', clientList());

  function clientList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowClient: '&',
      },
      controller: ClientListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/clients/client-list/client-list.component.html',
    };
  }

  ClientListComponent.$inject = [
    'UtilService',
    'AbilityService',
    'ClientService',
    'ClientTypeService',
    'ClientProfileService',
  ];

  function ClientListComponent(
    UtilService,
    AbilityService,
    ClientService,
    ClientTypeService,
    ClientProfileService
  ) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_client_accountadmin'),
      canUpdate: AbilityService.can('update_client_accountadmin'),
      canDestroy: AbilityService.can('destroy_client_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = ClientService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    vm.onUpdateItems = onUpdateItems;

    // Initializers
    getClientTypes();
    // getClientProfiles();

    function getClientTypes() {
      ClientTypeService.getClientTypes({ get: 'active', skip_check_role: true }).then(function (
        data
      ) {
        vm.clientTypes = data.items;
      });
    }

    function getClientProfiles() {
      ClientProfileService.getClientProfiles({ get: 'active', skip_check_role: true }).then(
        function (data) {
          vm.clientProfiles = data.items; // active_only_name
        }
      );
    }

    function fetchResult() {
      // What about offset and page ?? as found in services filterResult
      vm.loadingItems = true;
      ClientService.getClients(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = ClientService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(client, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowClient({ client: client, mode: mode });
    }

    function deleteItem(item) {
      ClientService.deleteClient(item, fetchResult);
    }

    function changeItemStatus(item) {
      ClientService.changeClientStatus(item);
    }

    function onUpdateItems(action) {
      var successCallback = function () {
        vm.selectedAll = false;

        if (action === 'destroy') {
          fetchResult();
        }
      };

      ClientService.updateClients(action, vm.items, successCallback);
    }
  }
})();
